import { Link } from "react-router-dom";
import Wrapper from "../../components/sectionWrapper";
import { media } from "../../libs/media";
import Messages from "./translations/PaymentLinkOverview.json";
// import Messages from "./translations/Secure.json";
import { useLangContext } from "../../components/translateContext";
// import buttonText from "../../translations/button.json";

import buttonText from "../../translations/button.json";
import { Bounce } from "react-reveal";
import { Icon } from "@iconify/react";
export default function PaymentLinkOverview() {
  const { Lang } = useLangContext();
  const Infos = { msg: Messages[Lang], button: buttonText[Lang] };
  return (
    <Wrapper childrenClassName="grid mb-10 relative" className="relative">
      <div className="w-full md:px-40 py-4 text-center ">
        <div className="">
          <h2>{Infos.msg.HelloText} </h2>
        </div>
        <div className="flex justify-center text-center ">
          <p className="mt-4 text-opacity-70" style={{ fontSize: 20 }}>
            {Infos.msg.description}
          </p>
        </div>
      </div>

      <div className="mt-1 w-full gap-2 ">
        <div className="w-full h-full md:mt-6">
          <img
            src={media.Logos.Links.paymentLinkOverview}
            alt="overview"
            className=""
          />
        </div>
      </div>
    </Wrapper>
  );
}
